import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  loggedIn = false;
  accountName: string | undefined = '';
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService
  ) {}

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe({
        next: () => {
          this.setLoginDisplay();
        },
        error: (err) => {
          console.error(err);
        }
    });
  }

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  setLoginDisplay() {
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.loggedIn = true;
      this.accountName = activeAccount.name;
    }
  }

  logout(): void {
    this.authService.logoutRedirect();
  }
}
